'use client';

import { useSyncExternalStore } from 'react';

import { STORAGE_KEY } from './constants/dismissal';

const listeners = new Set<() => void>();

// Held in memory too, so closing works for this visit even where storage is refused.
let dismissedThisVisit = false;

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Safari private mode throws on `localStorage` access alone; there the banner
// simply comes back on the next visit.
const isStoredAsDismissed = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

const getSnapshot = () => dismissedThisVisit || isStoredAsDismissed();

// The HTML is CDN-cached for every visitor, so the server always renders the
// banner and a returning visitor's dismissal applies once hydrated.
const getServerSnapshot = () => false;

export const dismissAppBanner = () => {
  dismissedThisVisit = true;
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // See `isStoredAsDismissed`.
  }
  listeners.forEach(listener => listener());
};

const useAppBannerDismissed = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

export default useAppBannerDismissed;
